// NOTE: Values manually added
export const letterSpacings = {
	// Values are in addition to Chakra default
	display: '-0.01em',
	ui: '-0.013em',
};
